import type { ContactConversationSummary } from '@repo/shared-types';

const time = (value: Date | string | null | undefined): number =>
  value ? new Date(value).getTime() : 0;

/**
 * The thread to reply in for a channel: the one the customer wrote in most
 * recently. A contact can have one WhatsApp thread per business number; our
 * own latest send (even a failed one) must not move replies to a number the
 * customer never messaged.
 */
export const pickReplyConversation = (
  conversations: ContactConversationSummary[],
  channel: ContactConversationSummary['channel'],
): ContactConversationSummary | undefined =>
  conversations
    .filter((c) => c.channel === channel)
    .sort(
      (a, b) =>
        time(b.last_inbound_at) - time(a.last_inbound_at) ||
        time(b.last_message_at) - time(a.last_message_at),
    )[0];
